// This module provides API call methods for Sephora Commerce
// Beauty Insider APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Beauty+Insider+APIs

const getBiPoints = require('services/api/beautyInsider/getBiPoints');
const getBiDigitalCardNumber = require('services/api/beautyInsider/getBiDigitalCardNumber');
const getBiAccountHistory = require('services/api/beautyInsider/getBiAccountHistory');
const createBiAccount = require('services/api/beautyInsider/createBiAccount');
const updateBiAccount = require('services/api/beautyInsider/updateBiAccount');
const unlinkBiAccount = require('services/api/beautyInsider/unlinkBiAccount');
const getPurchaseHistory = require('services/api/beautyInsider/getPurchaseHistory');
const addBiRewardsToCart = require('services/api/beautyInsider/addBiRewardsToCart');
const removeBiRewardFromBasket = require('services/api/beautyInsider/removeBiRewardFromBasket');
const getBiRewards = require('services/api/beautyInsider/getBiRewards');
const {
    getBiRewardsGroupForCheckout,
    getBiRewardsGroupForProfile,
    getBiRewardsGroupForSnapshot,
    getBiRewardsGroupForOrderConf
} = require('services/api/beautyInsider/getBiRewardsGroup');
const getClientSummary = require('services/api/beautyInsider/getClientSummary');
const getBiProfile = require('services/api/beautyInsider/getBiProfile');

module.exports = {
    getBiPoints,
    getBiDigitalCardNumber,
    getBiAccountHistory,
    createBiAccount,
    updateBiAccount,
    unlinkBiAccount,
    addBiRewardsToCart,
    removeBiRewardFromBasket,
    getPurchaseHistory,
    getBiRewardsGroupForCheckout,
    getBiRewardsGroupForProfile,
    getBiRewardsGroupForSnapshot,
    getBiRewardsGroupForOrderConf,
    getBiRewards,
    getClientSummary,
    getBiProfile
};
